import { configureStore } from "@reduxjs/toolkit";
import contactSlice from "../Conversation/contactSlice";
export const store = configureStore({
  reducer: {
    contactList: contactSlice,
  },
});
